import React from 'react'
import MaskedInput from 'react-text-mask'
export const EdicaoField = ({ inputRef, ...rest }) => {
  return <MaskedInput {...rest} mask={[/[0-9]/, /[0-9]/]} placeholderChar={'\u2000'} />
}

export default EdicaoField



// WEBPACK FOOTER //
// ./src/components/Fields/EdicaoField.js